export const Teams = () => {
    return (
        <section id="teams">
            <h2>For teams of all sizes</h2>
            <hr />
        </section>
    );
};
